import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { useState } from "react";
import { Delete, FileCopy } from "@material-ui/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { IFiles } from "../../../redux/types/types";
import { useStyles } from "../../../shared/styles/useStyles";
import clsx from "clsx";
import { MyTextField } from "../../custom/MyTextField";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { uiCloseModalAction } from "../../../redux/actions/uiActions";
import { startUploadAddicionalInformation } from "../../../redux/actions/documentManagmentActions";
import { IRequestAddicionalInformationForm } from "../../../interfaces/Correspondence";
import { SUPPORTED_FORMATS_FILE } from "../../../enums/enums";
import ValidationForm from "../../../utils/uploadFile/form/ValidationForm";
import { fileHandleSelect } from "../../../utils/uploadFile/FileValidation";
import { IFileValidation } from "../../../utils/uploadFile/interfaces/IFileValidation";

export const RequestAdditionalInformationForm = () => {
  const [fileNames, setFileNames] = useState<IFiles[]>([]);
  const [labelImage, setLabelImage] = useState("");

  const [validationData, setValidationData] = useState<IFileValidation>({
    noValid: false,
    noValidSize: false,
    noValidName: false,
    ok: false,
  });

  const dispatch = useDispatch();
  const intl = useIntl();
  const classes = useStyles();
  const initialValues: IRequestAddicionalInformationForm = {
    subjectAnnotation: "",
    annotation: "",
    attachedDocuments: [],
  };

  const validationSchema = yup.object({
    subjectAnnotation: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    annotation: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
  });

  const handleSelectFile = (e: any) => {
    setLabelImage("");

    const file = e.target.files[0] as File;
    const now = new Date().getTime().toString();

    if (file) {
      let validation = fileHandleSelect(file);
      setValidationData(validation);

      if (validation.ok) {
        return;
      }

      setFileNames((prevState) => [
        { url: "#", fileName: now + "_" + file.name, file },
        ...prevState,
      ]);
      setLabelImage(e.target.files[0].name);
    }
  };

  const handleDeleteFile = async (fileName: string, db: boolean) => {
    setFileNames([]);
  };

  const onClose = () => {
    dispatch(uiCloseModalAction());
  };

  return (
    <Formik
      validateOnChange={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        values.attachedDocuments = fileNames;
        await dispatch(startUploadAddicionalInformation(values));
        setSubmitting(false);
      }}
    >
      {({ values, isSubmitting }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <label className="form-text">
                <FormattedMessage id="SubjectAnnotation" />*
              </label>
              <MyTextField
                name="subjectAnnotation"
                variant="outlined"
                className={classes.myTextFieldRoot}
                //disabled={edit}
              />
            </Grid>

            <Grid item xs={12}>
              <label className="form-text">
                <FormattedMessage id="Annotation" />*
              </label>
              <MyTextField
                name="annotation"
                variant="outlined"
                className={classes.myTextFieldRoot}
                multiline
                rows={8}
              />
            </Grid>
            <Grid item xs={6}>
              <label className="form-text">
                <FormattedMessage id="AttachDocument" />
              </label>
              <TextField
                size="small"
                type="file"
                inputProps={{
                  accept: SUPPORTED_FORMATS_FILE.TYPE.join(","), // Convierte el array en un string separado por comas
                }}
                onChange={handleSelectFile}
                id="icon-button-file"
                autoComplete="off"
                style={{ display: "none" }}
              />

              <MyTextField
                disabled={true}
                variant="outlined"
                style={{ color: "black" }}
                value={labelImage}
                name="file"
                className={classes.myTextFieldRoot}
              />
            </Grid>

            <Grid item xs={6}>
              <Box mt={3} ml={-2}>
                <Tooltip
                  title={`${intl.formatMessage({ id: "SearchDocument" })}`}
                >
                  <label htmlFor="icon-button-file">
                    <IconButton component="span">
                      <FileCopy />
                    </IconButton>
                  </label>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <ValidationForm validationData={validationData} />
            </Grid>
          </Grid>
          {fileNames.map(({ fileName, url }) => {
            return (
              <Grid container key={fileName}>
                <Grid item xs={6} key={fileName}>
                  <Box style={{ fontSize: 12, color: "blue" }}>
                    <a href={url} target="__blank">
                      {fileName}
                    </a>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Tooltip title={`${intl.formatMessage({ id: "Delete" })}`}>
                    <IconButton
                      onClick={() => handleDeleteFile(fileName, url !== "#")}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            );
          })}

          <Box mt={2} display="flex" flexDirection="row-reverse" width={1}>
            {!isSubmitting ? (
              <Button
                className={clsx(classes.btn, classes.save)}
                autoFocus
                type="submit"
                disabled={isSubmitting}
              >
                <FormattedMessage id="Save" />
              </Button>
            ) : (
              <Button
                className={clsx(classes.btn, classes.save)}
                autoFocus
                type="button"
                disabled={true}
              >
                <CircularProgress className={classes.btnLoading} />
              </Button>
            )}
            <Button
              className={clsx(classes.btn, classes.cancel)}
              onClick={onClose}
            >
              <FormattedMessage id="Cancel" />
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
